// envelopes are treated as a cardType in the customization flow
export const ENVELOPE_CARD_TYPES = ['INVITATION_ENVELOPE', 'RSVP_ENVELOPE'];

export const ENVELOPE_PRINTING = {
  none: 'none',
  front: 'front',
  both: 'both',
};

export const RETURN_ADDRESSING = {
  none: 'NONE',
  front: 'FRONT',
  back: 'BACK',
};

export const getEnvelopePrintingValue = returnAddressingValue => {
  switch (returnAddressingValue) {
    case RETURN_ADDRESSING.back:
      return ENVELOPE_PRINTING.both;
    case RETURN_ADDRESSING.front:
      return ENVELOPE_PRINTING.front;
    default:
      return ENVELOPE_PRINTING.none;
  }
};
